import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {sTAgentsTableReady,rowsAgentsPerPageState,searchSTAgentTableTextState,paginationAgentsState,sTAgentsRowForAction,previousSTAgentFilterKitchen} from '../redux/stores'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/storeTable.css'

import STAgentsCollapsibleRow from './STAgentsCollapsibleRow'


//import {Kitchens} from '../../../common/DropDowns/index'


import * as Helpers from '../../../common/helpers'


function filterUnwantedData(sTAgentsData) {
    let array = []
    if (sTAgentsData && sTAgentsData.data && sTAgentsData.data.list) {
        array = sTAgentsData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.name = lineData.name ? lineData.name : "NA"
            newLineData.code = lineData.code ? lineData.code : "NA"
            newLineData.kitchen_counts = lineData.agent_assignments.length

            let agent_assignments = []
            
            for (let j = 0; j < lineData.agent_assignments.length; j++) {
                agent_assignments[j]={
                    "agent_assignment_id":lineData.agent_assignments[j].id,
                    "kitchen_name":lineData.agent_assignments[j].assigned_kitchen && lineData.agent_assignments[j].assigned_kitchen.name ? lineData.agent_assignments[j].assigned_kitchen.name : "NA",
                    "city_name":lineData.agent_assignments[j].assigned_kitchen && lineData.agent_assignments[j].assigned_kitchen.city && lineData.agent_assignments[j].assigned_kitchen.city.name ? lineData.agent_assignments[j].assigned_kitchen.city.name : "NA"
                    }                    
            }   
            newLineData.agent_assignments=agent_assignments;

            newArray[i] = newLineData
        }
    }
    return newArray
}


class STAgentsTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            sTAgentsData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            filter_kitchen_id:"",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(sTAgentsTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.ST_AGENTS_TABLE))

        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()
            let previousSTAgentFilterKitchen=""

        
         if (this.props.stores && this.props.stores.previousSTAgentFilterKitchen && this.props.stores.previousSTAgentFilterKitchen!==undefined) {
            previousSTAgentFilterKitchen=this.props.stores.previousSTAgentFilterKitchen
         }
         
        this.setState({
              filter_kitchen_id:previousSTAgentFilterKitchen
        },() => {
            this.getSTAgentsData();
        });        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }



    kitchenChange = (data) => {

       
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousSTAgentFilterKitchen(""))
             this.setState({
                filter_kitchen_id :"",            
            })
        }else{
            this.props.dispatch(previousSTAgentFilterKitchen(data.value))
             this.setState({
            filter_kitchen_id :data.value,
            
        })
        }
    }
    
    getSTAgentsData = () => {
        apiService.getSTAgentsData(this.state.filter_kitchen_id)
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData), pageNo = 1
                        if (this.props.stores && this.props.stores.previousAgentsPaginationValue) {
                            pageNo = this.props.stores.previousAgentsPaginationValue
                        }
                        this.setState({
                            sTAgentsData: array,
                            page: pageNo,
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(sTAgentsTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(sTAgentsTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.stores && this.props.stores.previousAgentsRowsPerPageValue) {
            value = this.props.stores.previousAgentsRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsAgentsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                    {/*
                        <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                            <div className="form-group">
                                <Kitchens kitchenChange={this.kitchenChange} selectedCity="0" selectedValue={this.state.filter_kitchen_id} />   
                            </div>
                        </div>
                    
                    <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredAgentList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>
                    </div>
                    */}
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.sTAgentsData.length>=(this.props.stores.previousAgentsPaginationValue*this.props.stores.previousAgentsRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.stores.previousAgentsPaginationValue*this.props.stores.previousAgentsRowsPerPageValue)-this.props.stores.previousAgentsRowsPerPageValue+1} to {this.props.stores.previousAgentsPaginationValue*this.props.stores.previousAgentsRowsPerPageValue} of {this.state.sTAgentsData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.stores.previousAgentsPaginationValue*this.props.stores.previousAgentsRowsPerPageValue)-this.props.stores.previousAgentsRowsPerPageValue+1} to {this.state.sTAgentsData.length} of {this.state.sTAgentsData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }
    getFilteredAgentList = () => {
       
        this.props.dispatch(sTAgentsTableReady(false))
        this.resetSearchAndPagination()
        this.getSTAgentsData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchSTAgentTableTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        
        this.setState({            
            filter_kitchen_id:""
        },() => {
            this.resetPagination()
            this.props.dispatch(sTAgentsTableReady(false))
            this.props.dispatch(searchSTAgentTableTextState(""))
            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")        
            this.props.dispatch(previousSTAgentFilterKitchen(""))
            this.getSTAgentsData()

        });

       
    }




    actionButtonsCreator = (cell, row) => {
        let addKitchen =""


    if(Helpers.checkPrivileges("/dashboard/storestickets/agents/add",this.props.user)){
        
            addKitchen=<button
                className="action-button"
                style={{ width: "150px", marginBottom: "1px" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.addKitchen(row)
                }}>
                Add Kitchen
            </button>
        }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{addKitchen}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationAgentsState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.stores && this.props.stores.previousAgentsPaginationValue
            && this.props.stores.previousAgentsPaginationValue !== 1) {
            this.props.dispatch(paginationAgentsState(1))
            this.setState({
                page: 1
            })
        }
    }

    addKitchen = (row) => {
        if (row && row.id) {
            this.props.dispatch(sTAgentsRowForAction(row))
            this.props.history.push("/dashboard/storestickets/agents/add")
        } else {
            this.dialog.show({
                title: "Employee id  Identification number not found",
                body: 'Employee id is not available, So not able add kitchen',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }


     expandComponent = row => {
        let row_id = ""
        if (row && row.id) {
            row_id = row.id
        }
        return <STAgentsCollapsibleRow row={row} row_id={row_id} />
    }

    isExpandableRow = row => {
        return true
    }

    expandColumnComponent = ({ isExpandableRow, isExpanded }) => {
        let downIconClassName = ""
        if (isExpandableRow) {
            downIconClassName = (isExpanded ? 'fa fa-angle-double-up' : 'fa fa-angle-double-down')
        } else {
            downIconClassName = ""
        }
        return (
            <div className="custom-expandable-row-indicator">
                <span className={downIconClassName} />
            </div>
        )
    }

    render() {
        let sizeperPage = 15

        if (this.props.stores && this.props.stores.previousAgentsRowsPerPageValue) {
            sizeperPage = this.props.stores.previousAgentsRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="sTAgents-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.sTAgentsData}
                    pagination={true}
                    expandableRow={this.isExpandableRow}
                    expandComponent={this.expandComponent}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight}}
                    expandColumnOptions={{
                        expandColumnVisible: true,
                        rerenderOnDataChange: true,
                        expandColumnComponent: this.expandColumnComponent,
                        columnWidth: 25
                    }}
                     >

                      

                      <TableHeaderColumn
                        dataField="id"
                        width="5"
                        isKey={true}
                        hidden={true}
                        expandable={false}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Id
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="code"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Emp. Id
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>


                      <TableHeaderColumn
                        dataField="kitchen_counts"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Kitchen Counts
                    </TableHeaderColumn>

                    
                    
                     <TableHeaderColumn
                        //width="110"
                        dataField="id"
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        stores: state.stores
    }
}

export default connect(mapStateToProps)(withRouter(STAgentsTable))


// WEBPACK FOOTER //
// ./src/modules/Stores/Components/STAgentsTable.js